import { getAsync, postAsync } from "./http-client";

const AnalyticsApi = {
  get: async (request) => {
    return await postAsync("/ceo/monthlyReport", request);
  },
  getStores: async (shopIndex) => {
    return await getAsync(`/ceo/storeNames/${shopIndex}`);
  },
  getStoresByDeliveryApp: async (shopIndex,appTypeCode) => {
    return await getAsync(`/ceo/storeNames/${shopIndex}/deliveryApp`,appTypeCode);
  },
};
export default AnalyticsApi;
